import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen h-screen overflow-y-auto bg-gray-50 flex flex-col items-center justify-center p-6 text-center">
            <div className="max-w-md w-full">
                <div className="mb-8 relative">
                    <h1 className="text-9xl font-black text-gray-200 select-none">404</h1>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <span className="text-2xl font-bold text-gray-900 bg-gray-50 px-4">Page Not Found</span>
                    </div>
                </div>

                <p className="text-gray-500 mb-8 font-medium">
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 font-bold rounded-xl border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-all text-sm group"
                    >
                        <ArrowLeft className="h-4 w-4 group-hover:-translate-x-1 transition-transform" />
                        Go Back
                    </button>

                    <button
                        onClick={() => navigate('/dashboard')}
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-orange-600 text-white font-bold rounded-xl hover:bg-orange-700 transition-all text-sm shadow-lg shadow-orange-100"
                    >
                        <Home className="h-4 w-4" />
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
